/**
 * 观看端文件下载服务
 * @returns
 */
import { fileDownloadAPI } from '../../request/index';
import BaseServer from '@/domain/common/base.server.js';
import useRoomBaseServer from '../room/roombase.server';
import useMsgServer from '@/domain/common/msg.server.js';
class FileDownloadServer extends BaseServer {
  constructor() {
    super();
    if (typeof FileDownloadServer.instance === 'object') {
      return FileDownloadServer.instance;
    }
    this.state = {
      showTab: true, //是否显示观看端tab
      menu_title: '文件下载',
      menu_id: ''
    };
    FileDownloadServer.instance = this;
    this.listenEvents()
    return this;
  }

  //监听msgServer通知
  listenEvents() {
    // 自定义消息
    useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
      console.log('CUSTOM_MSG', rawMsg)
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 商品更新
        case 'data_download_update':
          console.log('-----data_download_update', temp)
          if (temp.data && temp.data.menu_id) {
            this.state.menu_id = temp.data.menu_id
          }
          this.$emit('data_download_update', temp);
          break;
        default:
          break;
      }
    });
  }

  /**
   * 观看端文件列表
   * @param {string | number} menu_id 自定义菜单ID
   * @returns {object} {total:0,list:[]}
   */
  getFileDownloadList(menu_id) {
    const { watchInitData } = useRoomBaseServer().state;
    const data = {
      webinar_id: watchInitData.webinar.id,
      menu_id: menu_id * 1 ? menu_id : this.state.menu_id
    };
    return fileDownloadAPI.getFileDownloadList(data).then(res => {
      return res;
    });
  }

  // 观看端 检测下载
  /**
   *
   * @param {object} params
   * @param {} file_id 下载文件id
   * @param {} visit_id 游客id
   * @param {} menu_id 自定义菜单ID
   * @param {} webinar_id 活动ID
   * @param {number} download_type 下载来源 1:手机wap、2:pc网页、3:安卓SDK、4:ios-sdk、5:js-sdk、6:嵌入页
   * @returns {string}  download_url 下载地址
   */
  checkDownload(params = {}) {
    const { watchInitData } = useRoomBaseServer().state;
    if (params.menu_id) {
      params.menu_id = params.menu_id * 1 ? params.menu_id : this.state.menu_id
    }
    const data = {
      webinar_id: watchInitData.webinar.id,
      ...params
    };
    console.log('parm----', data)
    return fileDownloadAPI.checkDownload(data).then(res => {
      return res;
    });
  }

  setProperty(type, val) {
    this.state[type] = val
    this.$emit('changeDownloadProperty', this.state)
  }

  /**
   * 观看端下载
   * @param {*} params
   * @returns
   */
  download(params = {}) {
    return fileDownloadAPI.download(params).then(res => {
      return res;
    });
  }

  downloadListJson(params = {}) {
    return fileDownloadAPI.downloadListJson(params).then(res => {
      return res;
    });
  }
}

export default function useFileDownloadServer() {
  return new FileDownloadServer();
}
